(() => {
  // Beetroot offer cart guard (product.beetroot-reviewed). After every cart mutation it makes the $0 gift
  // lines match the Beetroot line in the cart, Rosabella rules: gifts only on subscribe; 2-pack = guide +
  // giveaway, 4-pack adds free shipping, 6-pack adds the mystery gift. One-time packs get no gifts.
  if (window.BeetrootOffer) return;
  const nativeFetch = window.fetch.bind(window);
  const G = { guide: 51440837787871, ship: 51440879829215, mystery: 51440837820639, cash: 51440837886175 };
  const gifts = [G.guide, G.ship, G.mystery, G.cash];
  const ALL = gifts;
  // variant id -> gifts it earns
  const RULES = new Map([
    [47547929526495, [G.guide, G.cash]],   // 2 Bottles · Subscribe (41956-839-2, 28 days)
    [51446639591647, ALL],                 // 6 Bottles · Subscribe (41956-839-6, 84 days)
    [47547929493727, []],                  // 2 Bottles · One-Time
    [51446639558879, []],                  // 6 Bottles · One-Time
    [51447463248095, [G.guide, G.ship, G.cash]],   // 4 Bottles · Subscribe (41956-839-4, 56 days)
    [51447463215327, []],                  // 4 Bottles · One-Time
    // legacy pack variants from the earlier version of this page
    [46722679177439, ALL], [46722679210207, ALL], [46722679832799, ALL], [46722679865567, ALL],
  ]);
  const root = window.Shopify?.routes?.root || "/";
  let queue = Promise.resolve(), checkoutBusy = false;

  async function request(path, body) {
    const r = await nativeFetch(root + path, body === undefined
      ? { credentials: "same-origin", cache: "no-store" }
      : { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) });
    const data = await r.json();
    if (!r.ok) throw Error(data.description || data.message || "Your cart could not be updated. Please try again.");
    return data;
  }
  const eligible = cart => cart.items.some(i => RULES.has(Number(i.variant_id)));
  const wanted = cart => {
    const set = new Set();
    for (const i of cart.items) for (const g of RULES.get(Number(i.variant_id)) || []) set.add(g);
    return set;
  };

  async function reconcile() {
    let cart = await request("cart.js");
    const want = wanted(cart), seen = new Set(), updates = {};
    for (const line of cart.items) {
      const id = Number(line.variant_id);
      if (!gifts.includes(id)) continue;
      const desired = want.has(id) && !seen.has(id) ? 1 : 0;
      seen.add(id);
      if (line.quantity !== desired) updates[line.key] = desired;
    }
    if (Object.keys(updates).length) cart = await request("cart/update.js", { updates });
    // Keep the page's order (guide, shipping, mystery, giveaway under the Beetroot line): Shopify lists newest first.
    const missing = gifts.filter(id => want.has(id) && !cart.items.some(i => Number(i.variant_id) === id));
    if (missing.length) {
      await request("cart/add.js", { items: missing.reverse().map(id => ({ id, quantity: 1, properties: { _gift: "beetroot-offer" } })) });
      cart = await request("cart.js");
    }
    return cart;
  }
  function sync() { const next = queue.then(reconcile, reconcile); queue = next.catch(() => {}); return next; }

  function showError(error, control) {
    let el = document.getElementById("beetroot-cart-error");
    if (!el) {
      el = document.createElement("p"); el.id = "beetroot-cart-error"; el.setAttribute("role", "alert");
      el.style.cssText = "color:#b42318;background:#fff3f0;padding:12px;font-size:15px;line-height:1.5";
      (control?.parentElement || document.body).append(el);
    }
    el.textContent = error.message || "Please try again."; el.hidden = false;
  }
  async function checkout(control) {
    if (checkoutBusy) return;
    checkoutBusy = true; control?.setAttribute("aria-busy", "true");
    try {
      const cart = await sync();
      if (!cart.items.length) throw Error("Choose your Beetroot pack before checking out.");
      location.assign(eligible(cart) ? root + "discount/BEETROOT-FREESHIP-2026?redirect=%2Fcheckout" : root + "checkout");
    } catch (e) { showError(e, control); checkoutBusy = false; control?.removeAttribute("aria-busy"); }
  }

  window.fetch = async function (input, init) {
    const url = new URL(typeof input == "string" ? input : input?.url || String(input), location.href);
    const mutation = url.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname)
      && (init?.method || input?.method || "GET").toUpperCase() !== "GET";
    const response = await nativeFetch(input, init);
    if (mutation && response.ok) {
      const before = await response.clone().json().catch(() => null), cart = await sync();
      if (before?.sections) {
        const keys = Object.keys(before.sections);
        const sr = await nativeFetch(root + "?sections=" + encodeURIComponent(keys.join(",")), { credentials: "same-origin" });
        if (sr.ok) {
          const sections = await sr.json(), headers = new Headers(response.headers);
          headers.delete("content-length"); headers.delete("content-encoding");
          return new Response(JSON.stringify({ ...before, ...(before.items && before.token ? cart : {}), sections }), { status: response.status, headers });
        }
      }
    }
    return response;
  };
  document.addEventListener("click", event => {
    const control = event.target.closest?.('button[name="checkout"],input[name="checkout"],a[href*="/checkout"]');
    if (!control || control.closest('form[action*="/cart/add"]')) return;
    event.preventDefault(); event.stopImmediatePropagation(); checkout(control);
  }, true);
  document.addEventListener("submit", event => {
    if (event.target.matches('form[action$="/cart"]') && event.submitter?.name === "checkout") {
      event.preventDefault(); event.stopImmediatePropagation(); checkout(event.submitter);
    }
  }, true);
  window.BeetrootOffer = { sync, checkout, request, eligible, gifts, showError };
})();
